module.exports = __webpack_public_path__ + "static/media/0016.97341453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48106/RAL/0016.png
// module id = 2549
// module chunks = 0